/**
 * PDPR (Pedagogical Practices) Chat API
 */
import apiClient from './client';

export interface PDPRConversation {
  conversation_id: string;
  username: string;
  title: string;
  created_at: string;
  updated_at: string;
}

export interface PDPRMessage {
  message_id: string;
  conversation_id: string;
  role: 'user' | 'assistant';
  content: string;
  created_at: string;
}

export interface PDPRConversationWithMessages {
  conversation: PDPRConversation;
  messages: PDPRMessage[];
}

export interface PDPRSendMessageResponse {
  user_message: PDPRMessage;
  assistant_message: PDPRMessage;
}

export const listPDPRConversations = async (): Promise<PDPRConversation[]> => {
  const response = await apiClient.get<PDPRConversation[]>('/pdpr/conversations');
  return response.data;
};

export const createPDPRConversation = async (): Promise<PDPRConversation> => {
  const response = await apiClient.post<PDPRConversation>('/pdpr/conversations');
  return response.data;
};

export const getPDPRConversation = async (conversationId: string): Promise<PDPRConversationWithMessages> => {
  const response = await apiClient.get<PDPRConversationWithMessages>(`/pdpr/conversations/${conversationId}`);
  return response.data;
};

export const deletePDPRConversation = async (conversationId: string): Promise<void> => {
  await apiClient.delete(`/pdpr/conversations/${conversationId}`);
};

export const sendPDPRMessage = async (
  conversationId: string,
  content: string,
): Promise<PDPRSendMessageResponse> => {
  const response = await apiClient.post<PDPRSendMessageResponse>(
    `/pdpr/conversations/${conversationId}/messages`,
    { content },
    { timeout: 120000 }, // 2 min — LLM can take a while
  );
  return response.data;
};
